import InfoOutlinedIcon from '@mui/icons-material/Info'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Tooltip, Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { MasterWorkoutExerciseSet } from 'src/types/MasterWorkoutExercise'
import MasterWorkoutExerciseViewModel from 'src/viewmodels/MasterWorkoutExerciseViewModel'
import MasterWorkoutExerciseSetsList from './MasterWorkoutExerciseSetsList'

interface MasterWorkoutExerciseDaysItemProps {
	viewModel: MasterWorkoutExerciseViewModel
	selected: boolean
	onSelect: (viewModel: MasterWorkoutExerciseViewModel) => void	
	canEdit: boolean
}

const MasterWorkoutExerciseDaysItem: FC<MasterWorkoutExerciseDaysItemProps> = ({ viewModel, selected, onSelect, canEdit }) => {
	const [expanded, setExpanded] = useState<boolean>(false)

	const { masterWorkoutExercise, addSet, editSet, removeSet } = viewModel

	const handleAccordionChange = () => {
		setExpanded(!expanded)
	}

	useEffect(() => {
		setExpanded(false)
	}, [masterWorkoutExercise.id])
	
	useEffect(() => {
		setExpanded(selected)
	}, [selected])

	return (
		<Accordion expanded={expanded || false} sx={{ width: '100%' }} TransitionProps={{ unmountOnExit: true }}>
			<AccordionSummary expandIcon={<ExpandMoreIcon onClick={handleAccordionChange} />}>
				<List sx={{ width: '100%', padding: 0, margin: 0 }}>
					<Divider />
					<ListItem>
						<Typography variant="h4" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
							{masterWorkoutExercise.masterGroupName || 'Main Lift'}
							{masterWorkoutExercise.resultListOrder && masterWorkoutExercise.id && (
								<Tooltip
									title={
										<Typography variant="caption" sx={{ color: 'white' }}>
											#{masterWorkoutExercise.resultListOrder}
											<Box component="span" sx={{ ml: 0.5, opacity: 0.7, fontSize: '0.9em' }}>
												(id: {masterWorkoutExercise.id})
											</Box>
										</Typography>
									}
								>
									<IconButton size="small" sx={{ ml: 0.5 }}>
										<InfoOutlinedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
									</IconButton>
								</Tooltip>
							)}
						</Typography>
					</ListItem>
					<ListItemButton selected={selected} onClick={() => onSelect(viewModel)}>
						<ListItemAvatar>
							<Avatar style={{ backgroundColor: 'black' }}>{`${masterWorkoutExercise.displayOrder + 1}`}</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={`${masterWorkoutExercise.masterExerciseName || 'n/a'}`}
							secondary={`Sets: ${masterWorkoutExercise.sets || 'n/a'} Reps: ${masterWorkoutExercise.reps || masterWorkoutExercise.repRange || 'n/a'} RIR: ${
								masterWorkoutExercise.rir || 'n/a'
							} Rest: ${masterWorkoutExercise.rest || 'n/a'}`}
						/>
					</ListItemButton>
				</List>
			</AccordionSummary>
			<AccordionDetails>
				<MasterWorkoutExerciseSetsList
					initialValues={masterWorkoutExercise.masterWorkoutExerciseSets}
					canEdit={canEdit}
					onAdd={addSet}
					onEdit={editSet}
					onRemove={removeSet}
				/>
			</AccordionDetails>
		</Accordion>
	)
}

export default MasterWorkoutExerciseDaysItem
